<template lang="pug">
b-modal#getMemberLabelList(
  ref="getMemberLabelList"
  :title="$t('ui.combine.get_member_label_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  hide-footer=true
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row.mb-2
      .col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.id')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="label_id"
            required
            type="text"
            :dirty="$v.label_id.$dirty"
            :error="$v.label_id.$error"
            v-model.trim.lazy="$v.label_id.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.label_id" :name="$t('ui.label_id')")
      .col-sm-12.col-md-6.col-lg-6
        b-form-group(:label="$t('ui.name')" disabled).mb-0
          DebounceInput(
            size="sm"
            ref="label_name"
            required
            type="text"
            :dirty="$v.label_name.$dirty"
            :error="$v.label_name.$error"
            v-model.trim.lazy="$v.label_name.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.label_name" :name="$t('ui.label_name')")
    .row
      .col-sm-12.col-md-7
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)").mb-1
      .col-sm-12.col-md-5
        b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
          b-form-select(:options="$store.getters.mbLabelPageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-sm-12.col-md-12.col-lg-12
        b-form-group(:label="$t('ui.member_list')" style="overflow: hidden scroll; height: 35vh; max-height: 70vh;").mb-3
          div.row
            div.col
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center
                      span.text-center #
                    th
                      span {{ $t('ui.id') }}
                tbody
                  tr(v-if="memberLabelList.length == 0")
                    td(colspan="2").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in memberLabelList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    td
                      span(:title="item.account_id") {{ item.account_id }}
    .row
      jsonToExcel.m-auto(v-if="memberLabelList.length > 0" tbl="tblList" type="1" mode="tableToExcelCustomMember" :date="dateRange" :loading="loading")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    jsonToExcel
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      label_id: "",
      label_name: "",
      memberLabelList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPage: 1,
      totalRow: 0,
      sortKey: "account_id",
      sortType: "asc",
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.mbLabelPageSize;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    label_id: {
      required
    },
    label_name: {
      required,
      maxLength: maxLength(50)
    },
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setMbLabelPageSize", pageSize);
      this.currentPage = 1;
      this.getMemberLabelList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getMemberLabelList();
    },
    getMemberLabelList: function(isSearch) {
      let url = config.memberLabelListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        label_id: this.label_id,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberLabelList = response.data.dt;
                this.totalRow = this.memberLabelList.length > 0 ? this.memberLabelList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.memberLabelList = [];
      this.label_id = this.item.label_id;
      this.label_name = this.item.label_name;
      this.getMemberLabelList();
    }
  }
};
</script>
